import React from "react";

// ── Business Domain ──
import BusinessDomainListPage from "../pages/design/BusinessDomainListPage";
import BusinessDomainCreatePage from "../pages/design/BusinessDomainCreatePage";
import BusinessDomainDetailPage from "../pages/design/BusinessDomainDetailPage";
import BusinessDomainEditPage from "../pages/design/BusinessDomainEditPage";
// ── Customer Type ──
import CustomerTypeListPage from "../pages/design/CustomerTypeListPage";
import CustomerTypeCreatePage from "../pages/design/CustomerTypeCreatePage";
import CustomerTypeDetailPage from "../pages/design/CustomerTypeDetailPage";
import CustomerTypeEditPage from "../pages/design/CustomerTypeEditPage";
// ── Product Type ──
import ProductTypeListPage from "../pages/design/ProductTypeListPage";
import ProductTypeCreatePage from "../pages/design/ProductTypeCreatePage";
import ProductTypeDetailPage from "../pages/design/ProductTypeDetailPage";
import ProductTypeEditPage from "../pages/design/ProductTypeEditPage";
// ── Member Type ──
import MemberTypeListPage from "../pages/design/MemberTypeListPage";
import MemberTypeCreatePage from "../pages/design/MemberTypeCreatePage";
import MemberTypeDetailPage from "../pages/design/MemberTypeDetailPage";
import MemberTypeEditPage from "../pages/design/MemberTypeEditPage";
// ── Partner Type ──
import PartnerTypeListPage from "../pages/design/PartnerTypeListPage";
import PartnerTypeCreatePage from "../pages/design/PartnerTypeCreatePage";
import PartnerTypeDetailPage from "../pages/design/PartnerTypeDetailPage";
import PartnerTypeEditPage from "../pages/design/PartnerTypeEditPage";
// ── Job ──
import JobListPage from "../pages/design/JobListPage";
import JobCreatePage from "../pages/design/JobCreatePage";
import JobDetailPage from "../pages/design/JobDetailPage";
import JobEditPage from "../pages/design/JobEditPage";
// ── Task ──
import TaskListPage from "../pages/design/TaskListPage";
import TaskCreatePage from "../pages/design/TaskCreatePage";
import TaskDetailPage from "../pages/design/TaskDetailPage";
import TaskEditPage from "../pages/design/TaskEditPage";
// ── Business Process ──
import BusinessProcessListPage from "../pages/design/BusinessProcessListPage";
import BusinessProcessCreatePage from "../pages/design/BusinessProcessCreatePage";
import BusinessProcessDetailPage from "../pages/design/BusinessProcessDetailPage";
import BusinessProcessEditPage from "../pages/design/BusinessProcessEditPage";
// ── Data Type ──
import DataTypeListPage from "../pages/design/DataTypeListPage";
import DataTypeCreatePage from "../pages/design/DataTypeCreatePage";
import DataTypeDetailPage from "../pages/design/DataTypeDetailPage";
import DataTypeEditPage from "../pages/design/DataTypeEditPage";
// ── Data Item ──
import DataItemDetailPage from "../pages/design/DataItemDetailPage";
import DataItemCreatePage from "../pages/design/DataItemCreatePage";
import DataItemEditPage from "../pages/design/DataItemEditPage";
// ── Application Type ──
import ApplicationTypeListPage from "../pages/design/ApplicationTypeListPage";
import ApplicationTypeCreatePage from "../pages/design/ApplicationTypeCreatePage";
import ApplicationTypeDetailPage from "../pages/design/ApplicationTypeDetailPage";
import ApplicationTypeEditPage from "../pages/design/ApplicationTypeEditPage";
// ── IT Type ──
import ItTypeListPage from "../pages/design/ItTypeListPage";
import ItTypeCreatePage from "../pages/design/ItTypeCreatePage";
import ItTypeDetailPage from "../pages/design/ItTypeDetailPage";
import ItTypeEditPage from "../pages/design/ItTypeEditPage";
// ── Place Type ──
import PlaceTypeListPage from "../pages/design/PlaceTypeListPage";
import PlaceTypeCreatePage from "../pages/design/PlaceTypeCreatePage";
import PlaceTypeDetailPage from "../pages/design/PlaceTypeDetailPage";
import PlaceTypeEditPage from "../pages/design/PlaceTypeEditPage";
// ── Financial Asset Type ──
import FinancialAssetTypeListPage from "../pages/design/FinancialAssetTypeListPage";
import FinancialAssetTypeCreatePage from "../pages/design/FinancialAssetTypeCreatePage";
import FinancialAssetTypeDetailPage from "../pages/design/FinancialAssetTypeDetailPage";
import FinancialAssetTypeEditPage from "../pages/design/FinancialAssetTypeEditPage";
// ── Company Values (経営理念) ──
import CompanyValuesPage from "../pages/design/CompanyValuesPage";
// ── Business KPI (事業指標) ──
import BusinessKpiListPage from "../pages/design/BusinessKpiListPage";
import BusinessKpiCreatePage from "../pages/design/BusinessKpiCreatePage";
import BusinessKpiDetailPage from "../pages/design/BusinessKpiDetailPage";
import BusinessKpiEditPage from "../pages/design/BusinessKpiEditPage";
// ── Data Domain (データドメイン) ──
import DataDomainListPage from "../pages/design/DataDomainListPage";
import DataDomainCreatePage from "../pages/design/DataDomainCreatePage";
import DataDomainDetailPage from "../pages/design/DataDomainDetailPage";
import DataDomainEditPage from "../pages/design/DataDomainEditPage";
// ── Value Chain (バリューチェーン) ──
import ValueChainListPage from "../pages/design/ValueChainListPage";
import ValueChainCreatePage from "../pages/design/ValueChainCreatePage";
import ValueChainDetailPage from "../pages/design/ValueChainDetailPage";
import ValueChainEditPage from "../pages/design/ValueChainEditPage";
// ── Strategy Map (戦略マップ) ──
import SmFinancialGoalListPage from "../pages/design/SmFinancialGoalListPage";
import SmFinancialGoalDetailPage from "../pages/design/SmFinancialGoalDetailPage";
import SmFinancialGoalCreatePage from "../pages/design/SmFinancialGoalCreatePage";
import SmFinancialGoalEditPage from "../pages/design/SmFinancialGoalEditPage";
import SmCustomerValueListPage from "../pages/design/SmCustomerValueListPage";
import SmCustomerValueDetailPage from "../pages/design/SmCustomerValueDetailPage";
import SmCustomerValueCreatePage from "../pages/design/SmCustomerValueCreatePage";
import SmCustomerValueEditPage from "../pages/design/SmCustomerValueEditPage";
import SmStrategicGoalListPage from "../pages/design/SmStrategicGoalListPage";
import SmStrategicGoalDetailPage from "../pages/design/SmStrategicGoalDetailPage";
import SmStrategicGoalCreatePage from "../pages/design/SmStrategicGoalCreatePage";
import SmStrategicGoalEditPage from "../pages/design/SmStrategicGoalEditPage";
import SmOrgCapitalGoalListPage from "../pages/design/SmOrgCapitalGoalListPage";
import SmOrgCapitalGoalDetailPage from "../pages/design/SmOrgCapitalGoalDetailPage";
import SmOrgCapitalGoalCreatePage from "../pages/design/SmOrgCapitalGoalCreatePage";
import SmOrgCapitalGoalEditPage from "../pages/design/SmOrgCapitalGoalEditPage";
import SmInfoCapitalGoalAppListPage from "../pages/design/SmInfoCapitalGoalAppListPage";
import SmInfoCapitalGoalAppDetailPage from "../pages/design/SmInfoCapitalGoalAppDetailPage";
import SmInfoCapitalGoalAppCreatePage from "../pages/design/SmInfoCapitalGoalAppCreatePage";
import SmInfoCapitalGoalAppEditPage from "../pages/design/SmInfoCapitalGoalAppEditPage";
import SmInfoCapitalGoalDataListPage from "../pages/design/SmInfoCapitalGoalDataListPage";
import SmInfoCapitalGoalDataDetailPage from "../pages/design/SmInfoCapitalGoalDataDetailPage";
import SmInfoCapitalGoalDataCreatePage from "../pages/design/SmInfoCapitalGoalDataCreatePage";
import SmInfoCapitalGoalDataEditPage from "../pages/design/SmInfoCapitalGoalDataEditPage";
import SmInfoCapitalGoalItListPage from "../pages/design/SmInfoCapitalGoalItListPage";
import SmInfoCapitalGoalItDetailPage from "../pages/design/SmInfoCapitalGoalItDetailPage";
import SmInfoCapitalGoalItCreatePage from "../pages/design/SmInfoCapitalGoalItCreatePage";
import SmInfoCapitalGoalItEditPage from "../pages/design/SmInfoCapitalGoalItEditPage";
// ── Strategic Issue (戦略目標) ──
import SmStrategicIssueListPage from "../pages/design/SmStrategicIssueListPage";
import SmStrategicIssueDetailPage from "../pages/design/SmStrategicIssueDetailPage";
import SmStrategicIssueCreatePage from "../pages/design/SmStrategicIssueCreatePage";
import SmStrategicIssueEditPage from "../pages/design/SmStrategicIssueEditPage";
// ── Human Capital Goal (人的資本目標) ──
import SmHumanCapitalGoalListPage from "../pages/design/SmHumanCapitalGoalListPage";
import SmHumanCapitalGoalDetailPage from "../pages/design/SmHumanCapitalGoalDetailPage";
import SmHumanCapitalGoalCreatePage from "../pages/design/SmHumanCapitalGoalCreatePage";
import SmHumanCapitalGoalEditPage from "../pages/design/SmHumanCapitalGoalEditPage";

const designRoutes = [
  // Business Domain
  { path: "business-domains", element: <BusinessDomainListPage /> },
  { path: "business-domains/create", element: <BusinessDomainCreatePage /> },
  { path: ":businessDomainId", element: <BusinessDomainDetailPage /> },
  { path: ":businessDomainId/edit", element: <BusinessDomainEditPage /> },

  // Customer Type
  { path: ":businessDomainId/customer-types", element: <CustomerTypeListPage /> },
  { path: ":businessDomainId/customer-types/create", element: <CustomerTypeCreatePage /> },
  { path: ":businessDomainId/customer-types/:customerTypeId", element: <CustomerTypeDetailPage /> },
  { path: ":businessDomainId/customer-types/:customerTypeId/edit", element: <CustomerTypeEditPage /> },

  // Product Type
  { path: ":businessDomainId/product-types", element: <ProductTypeListPage /> },
  { path: ":businessDomainId/product-types/create", element: <ProductTypeCreatePage /> },
  { path: ":businessDomainId/product-types/:productTypeId", element: <ProductTypeDetailPage /> },
  { path: ":businessDomainId/product-types/:productTypeId/edit", element: <ProductTypeEditPage /> },

  // Member Type
  { path: ":businessDomainId/member-types", element: <MemberTypeListPage /> },
  { path: ":businessDomainId/member-types/create", element: <MemberTypeCreatePage /> },
  { path: ":businessDomainId/member-types/:memberTypeId", element: <MemberTypeDetailPage /> },
  { path: ":businessDomainId/member-types/:memberTypeId/edit", element: <MemberTypeEditPage /> },

  // Partner Type
  { path: ":businessDomainId/partner-types", element: <PartnerTypeListPage /> },
  { path: ":businessDomainId/partner-types/create", element: <PartnerTypeCreatePage /> },
  { path: ":businessDomainId/partner-types/:partnerTypeId", element: <PartnerTypeDetailPage /> },
  { path: ":businessDomainId/partner-types/:partnerTypeId/edit", element: <PartnerTypeEditPage /> },

  // Job
  { path: ":businessDomainId/jobs", element: <JobListPage /> },
  { path: ":businessDomainId/jobs/create", element: <JobCreatePage /> },
  { path: ":businessDomainId/jobs/:jobId", element: <JobDetailPage /> },
  { path: ":businessDomainId/jobs/:jobId/edit", element: <JobEditPage /> },

  // Task (nested under Job)
  { path: ":businessDomainId/jobs/:jobId/tasks", element: <TaskListPage /> },
  { path: ":businessDomainId/jobs/:jobId/tasks/create", element: <TaskCreatePage /> },
  { path: ":businessDomainId/jobs/:jobId/tasks/:taskId", element: <TaskDetailPage /> },
  { path: ":businessDomainId/jobs/:jobId/tasks/:taskId/edit", element: <TaskEditPage /> },

  // Business Process
  { path: ":businessDomainId/business-processes", element: <BusinessProcessListPage /> },
  { path: ":businessDomainId/business-processes/create", element: <BusinessProcessCreatePage /> },
  { path: ":businessDomainId/business-processes/:businessProcessId", element: <BusinessProcessDetailPage /> },
  { path: ":businessDomainId/business-processes/:businessProcessId/edit", element: <BusinessProcessEditPage /> },

  // Data Type
  { path: ":businessDomainId/data-types", element: <DataTypeListPage /> },
  { path: ":businessDomainId/data-types/create", element: <DataTypeCreatePage /> },
  { path: ":businessDomainId/data-types/:dataTypeId", element: <DataTypeDetailPage /> },
  { path: ":businessDomainId/data-types/:dataTypeId/edit", element: <DataTypeEditPage /> },
  // Data Item (nested under Data Type)
  { path: ":businessDomainId/data-types/:dataTypeId/data-items/create", element: <DataItemCreatePage /> },
  { path: ":businessDomainId/data-types/:dataTypeId/data-items/:dataItemId", element: <DataItemDetailPage /> },
  { path: ":businessDomainId/data-types/:dataTypeId/data-items/:dataItemId/edit", element: <DataItemEditPage /> },

  // Application Type
  { path: ":businessDomainId/application-types", element: <ApplicationTypeListPage /> },
  { path: ":businessDomainId/application-types/create", element: <ApplicationTypeCreatePage /> },
  { path: ":businessDomainId/application-types/:applicationTypeId", element: <ApplicationTypeDetailPage /> },
  { path: ":businessDomainId/application-types/:applicationTypeId/edit", element: <ApplicationTypeEditPage /> },

  // IT Type
  { path: ":businessDomainId/it-types", element: <ItTypeListPage /> },
  { path: ":businessDomainId/it-types/create", element: <ItTypeCreatePage /> },
  { path: ":businessDomainId/it-types/:itTypeId", element: <ItTypeDetailPage /> },
  { path: ":businessDomainId/it-types/:itTypeId/edit", element: <ItTypeEditPage /> },

  // Place Type
  { path: ":businessDomainId/place-types", element: <PlaceTypeListPage /> },
  { path: ":businessDomainId/place-types/create", element: <PlaceTypeCreatePage /> },
  { path: ":businessDomainId/place-types/:placeTypeId", element: <PlaceTypeDetailPage /> },
  { path: ":businessDomainId/place-types/:placeTypeId/edit", element: <PlaceTypeEditPage /> },

  // Financial Asset Type
  { path: ":businessDomainId/financial-asset-types", element: <FinancialAssetTypeListPage /> },
  { path: ":businessDomainId/financial-asset-types/create", element: <FinancialAssetTypeCreatePage /> },
  { path: ":businessDomainId/financial-asset-types/:financialAssetTypeId", element: <FinancialAssetTypeDetailPage /> },
  { path: ":businessDomainId/financial-asset-types/:financialAssetTypeId/edit", element: <FinancialAssetTypeEditPage /> },

  // Company Values (経営理念 - 表示・更新)
  { path: "company-values", element: <CompanyValuesPage /> },

  // Business KPI
  { path: ":businessDomainId/business-kpis", element: <BusinessKpiListPage /> },
  { path: ":businessDomainId/business-kpis/create", element: <BusinessKpiCreatePage /> },
  { path: ":businessDomainId/business-kpis/:businessKpiId", element: <BusinessKpiDetailPage /> },
  { path: ":businessDomainId/business-kpis/:businessKpiId/edit", element: <BusinessKpiEditPage /> },

  // Data Domain
  { path: ":businessDomainId/data-domains", element: <DataDomainListPage /> },
  { path: ":businessDomainId/data-domains/create", element: <DataDomainCreatePage /> },
  { path: ":businessDomainId/data-domains/:dataDomainId", element: <DataDomainDetailPage /> },
  { path: ":businessDomainId/data-domains/:dataDomainId/edit", element: <DataDomainEditPage /> },

  // Value Chain
  { path: ":businessDomainId/value-chains", element: <ValueChainListPage /> },
  { path: ":businessDomainId/value-chains/create", element: <ValueChainCreatePage /> },
  { path: ":businessDomainId/value-chains/:valueChainId", element: <ValueChainDetailPage /> },
  { path: ":businessDomainId/value-chains/:valueChainId/edit", element: <ValueChainEditPage /> },

  // Strategy Map - Financial Goal
  { path: ":businessDomainId/strategy-map/financial-goals", element: <SmFinancialGoalListPage /> },
  { path: ":businessDomainId/strategy-map/financial-goals/create", element: <SmFinancialGoalCreatePage /> },
  { path: ":businessDomainId/strategy-map/financial-goals/:successFactorId", element: <SmFinancialGoalDetailPage /> },
  { path: ":businessDomainId/strategy-map/financial-goals/:successFactorId/edit", element: <SmFinancialGoalEditPage /> },
  // Strategy Map - Customer Value
  { path: ":businessDomainId/strategy-map/customer-values", element: <SmCustomerValueListPage /> },
  { path: ":businessDomainId/strategy-map/customer-values/create", element: <SmCustomerValueCreatePage /> },
  { path: ":businessDomainId/strategy-map/customer-values/:successFactorId", element: <SmCustomerValueDetailPage /> },
  { path: ":businessDomainId/strategy-map/customer-values/:successFactorId/edit", element: <SmCustomerValueEditPage /> },
  // Strategy Map - Strategic Goal
  { path: ":businessDomainId/strategy-map/strategic-goals", element: <SmStrategicGoalListPage /> },
  { path: ":businessDomainId/strategy-map/strategic-goals/create", element: <SmStrategicGoalCreatePage /> },
  { path: ":businessDomainId/strategy-map/strategic-goals/:successFactorId", element: <SmStrategicGoalDetailPage /> },
  { path: ":businessDomainId/strategy-map/strategic-goals/:successFactorId/edit", element: <SmStrategicGoalEditPage /> },
  // Strategy Map - Org Capital Goal
  { path: ":businessDomainId/strategy-map/org-capital-goals", element: <SmOrgCapitalGoalListPage /> },
  { path: ":businessDomainId/strategy-map/org-capital-goals/create", element: <SmOrgCapitalGoalCreatePage /> },
  { path: ":businessDomainId/strategy-map/org-capital-goals/:successFactorId", element: <SmOrgCapitalGoalDetailPage /> },
  { path: ":businessDomainId/strategy-map/org-capital-goals/:successFactorId/edit", element: <SmOrgCapitalGoalEditPage /> },
  // Strategy Map - Info Capital Goal (App)
  { path: ":businessDomainId/strategy-map/info-capital-goals-app", element: <SmInfoCapitalGoalAppListPage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-app/create", element: <SmInfoCapitalGoalAppCreatePage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-app/:successFactorId", element: <SmInfoCapitalGoalAppDetailPage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-app/:successFactorId/edit", element: <SmInfoCapitalGoalAppEditPage /> },
  // Strategy Map - Info Capital Goal (Data)
  { path: ":businessDomainId/strategy-map/info-capital-goals-data", element: <SmInfoCapitalGoalDataListPage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-data/create", element: <SmInfoCapitalGoalDataCreatePage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-data/:successFactorId", element: <SmInfoCapitalGoalDataDetailPage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-data/:successFactorId/edit", element: <SmInfoCapitalGoalDataEditPage /> },
  // Strategy Map - Info Capital Goal (IT)
  { path: ":businessDomainId/strategy-map/info-capital-goals-it", element: <SmInfoCapitalGoalItListPage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-it/create", element: <SmInfoCapitalGoalItCreatePage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-it/:successFactorId", element: <SmInfoCapitalGoalItDetailPage /> },
  { path: ":businessDomainId/strategy-map/info-capital-goals-it/:successFactorId/edit", element: <SmInfoCapitalGoalItEditPage /> },
  // Strategy Map - Strategic Issue (戦略目標)
  { path: ":businessDomainId/strategy-map/strategic-issues", element: <SmStrategicIssueListPage /> },
  { path: ":businessDomainId/strategy-map/strategic-issues/create", element: <SmStrategicIssueCreatePage /> },
  { path: ":businessDomainId/strategy-map/strategic-issues/:successFactorId", element: <SmStrategicIssueDetailPage /> },
  { path: ":businessDomainId/strategy-map/strategic-issues/:successFactorId/edit", element: <SmStrategicIssueEditPage /> },
  // Strategy Map - Human Capital Goal (人的資本目標)
  { path: ":businessDomainId/strategy-map/human-capital-goals", element: <SmHumanCapitalGoalListPage /> },
  { path: ":businessDomainId/strategy-map/human-capital-goals/create", element: <SmHumanCapitalGoalCreatePage /> },
  { path: ":businessDomainId/strategy-map/human-capital-goals/:successFactorId", element: <SmHumanCapitalGoalDetailPage /> },
  { path: ":businessDomainId/strategy-map/human-capital-goals/:successFactorId/edit", element: <SmHumanCapitalGoalEditPage /> },
];

export default designRoutes;
